import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HomeworkActivityQuery, HomeworkActivityService } from '@examdojo/homework';
import { QuestionAttemptEntityService } from '@examdojo/question';
import { isNotNullish } from '@examdojo/util/nullish';
import { filter, pairwise, switchMap, tap } from 'rxjs';
import { HomeworkActivityDialogService } from '../dialog/homework-activity-dialog.service';

@Injectable()
export class CloseHomeworkDialogEffectService {
  constructor(
    private readonly homeworkActivityQuery: HomeworkActivityQuery,
    private readonly homeworkActivityService: HomeworkActivityService,
    private readonly questionAttemptService: QuestionAttemptEntityService,
    private readonly homeworkActivityDialogService: HomeworkActivityDialogService,
  ) {
    this.handleCloseHomeworkActivityDialog().pipe(takeUntilDestroyed()).subscribe();
  }

  private handleCloseHomeworkActivityDialog() {
    return this.homeworkActivityQuery.ongoingActivityId$.pipe(
      pairwise(),
      filter(([prev, curr]) => isNotNullish(prev) && !isNotNullish(curr)),
      filter(() => this.homeworkActivityDialogService.isOpen()),
      switchMap(() => this.homeworkActivityDialogService.dismiss()),
      tap(() => {
        this.homeworkActivityService.clearActive();
        this.questionAttemptService.resetStore();
      }),
    );
  }
}
